import React, { useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Col,
    Icon,
    PreviewAltCard,
    Row,
} from "../../../components/Component";
import { Button, Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyDate from "../../../MyComp/UI/form/MyDate";
import MySelect from "../../../MyComp/UI/form/MySelect";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import moment from "moment";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { StepHead } from "./DocFormHeader";
import MyPAN from "../../../MyComp/UI/form/MyPAN";
import MyAadhaar from "../../../MyComp/UI/form/MyAadhaar";
import { doctorProfileRegistration } from "../../../api/doctor";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import { departmentDropDownList } from "../../../api/Hospital/index";
import { useEffect } from "react";
import { specializationDropDownList } from "../../../api/Hospital/index";
import { addHospitalDoctor } from "../../../api/Hospital/index";
// import { useLocation } from "react-router-dom";
import { BASE_URL_IMG } from "../../../assets/constants";
import { updateHospitalDoctor } from "../../../api/Hospital/index";




const DoctorForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useLogout();
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: false,
            agreed: false,
            medical_qualification: null,
            qualificationDD: [],
            specializationDD: [],

            profile_image: null,
            profile_img: null,

            pan_image: null,
            pan_img: null,

            cert_image: null,
            cert_img: null,

            aadhaar_f_image: null,
            aadhaar_f_img: null,

            aadhaar_b_image: null,
            aadhaar_b_img: null,

            objectionKeys: [],
            approvedKeys: [],

            degree: [
                {
                    certificate: null,
                    certificate_url: null,
                },
            ],
            qualifications: [
                {
                    degree_name: "",
                    institution_name: "",
                    year_of_passing: null,
                },
            ],
            experiences: [
                {
                    organization: "",
                    from_date: null,
                    to_date: null,
                    department_id: "",
                    is_current: false,
                    description: "",
                },
            ],
            mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const { mode: pageMode, dataEdit } = location.state || {};
   

    useEffect(() => {
        if (pageMode === "Edit" && dataEdit) {

            setValue("name", dataEdit?.full_name || "");
            setValue("email", dataEdit?.email || "");
            setValue("mobile", dataEdit?.phone || "");

            setValue(
                "dob",
                dataEdit?.date_of_birth && !isNaN(new Date(dataEdit.date_of_birth))
                    ? new Date(dataEdit.date_of_birth)
                    : null
            );

            setValue("gender", dataEdit?.gender
                ? { label: dataEdit.gender, value: dataEdit.gender }
                : null
            );

            setValue("address", dataEdit?.address || "");
            setValue("medicalSchool", dataEdit?.medical_school || "");
            setValue("graduationYear", dataEdit?.graduation_year || "");
            setValue("yearsOfExperience", dataEdit?.years_of_experience || "");

            // ✅ Department (IMPORTANT)
            setValue("test", dataEdit?.departmentId
                ? {
                    label: dataEdit?.departmentName,
                    value: dataEdit?.departmentId
                }
                : null
            );

            // ✅ Specialization
            setValue("specialization", dataEdit?.specializationId
                ? {
                    label: dataEdit?.specializationName,
                    value: dataEdit?.specializationId
                }
                : null
            );

            // ✅ Image preview
            if (dataEdit?.photo) {
                const imageUrl = `${BASE_URL_IMG}${dataEdit.photo}`;

                setValue("profile_image", imageUrl); // preview
                setValue("profile_img", imageUrl);   // important for payload logic
            }
        }
    }, [pageMode, dataEdit, setValue]);

    const selectedDepartment = watch("test");
    // const [mode, setMode] = useState(location?.state?.mode || "Add");
    const mode = location?.state?.mode || "Add";
    const doctorId = location?.state?.doctorId || ""
    const isLoading = watch("isLoading");
    const [imageOpen, setImageOpen] = useState(false);
    const [departments, setDepartments] = useState([]);
    // const location = useLocation();
    // const { mode, data } = location.state || {};

    const [specializationOptions, setSpecializationOptions] = useState([]);
    const handleImageOpenPreview = (row) => {
        const imageUrl = `${row?.image}`;
        setValue("image_preview", imageUrl);
        setImageOpen(true);
    };

    const onFormSubmit = async (data) => {
        try {
            const formData = new FormData();
            // ✅ Basic Details
            formData.append("full_name", data?.name || "");
            formData.append("email", data?.email || "");
            formData.append("phone", data?.mobile || "");

            formData.append(
                "date_of_birth",
                data?.dob ? moment(data.dob).format("YYYY-MM-DD") : ""
            );

            formData.append("gender", data?.gender?.value || "");


            // ✅ Department & Specialization
            formData.append("departmentId", data?.test?.value || "");
            formData.append("specializationId", data?.specialization?.value || "");

            // ✅ Extra Fields
            formData.append("address", data?.address || "");
            formData.append("medical_school", data?.medicalSchool || "");
            formData.append("graduation_year", data?.graduationYear || "");
            formData.append("years_of_experience", data?.yearsOfExperience || "");

            // ✅ Profile Image
            if (data?.profile_img instanceof File) {
                formData.append("image", data.profile_img);
            }

            // ✅ PAN Image
            if (data?.pan_img instanceof File) {
                formData.append("pan_image", data.pan_img);
            }

            // ✅ Certificate Image
            if (data?.cert_img instanceof File) {
                formData.append("cert_image", data.cert_img);
            }

            // ✅ Aadhaar Front Image
            if (data?.aadhaar_f_img instanceof File) {
                formData.append("aadhaar_f_image", data.aadhaar_f_img);
            }

            // ✅ Aadhaar Back Image
            if (data?.aadhaar_b_img instanceof File) {
                formData.append("aadhaar_b_image", data.aadhaar_b_img);
            }

            // ✅ DEBUG (VERY IMPORTANT)
            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }

            // ✅ API CALL
            if (mode === "Add") {
                setValue("isLoading", true);

                const res = await addHospitalDoctor(formData);

                setValue("isLoading", false);

                if (res?.data?.status === true) {
                    toast.success(res.data.message);

                    // ✅ Optional navigation
                    navigate("/doctor-additional-details", {
                        state: {
                            doctorId: res?.data?.data?.doctorId || doctorId,
                            mode: "Add"
                        }
                    });
                } else if (res?.data?.status === false) {
                    toast.error(res.data.message);
                } else if (res?.data?.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
            }

        } catch (error) {
            setValue("isLoading", false);
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    const updateDoctorEdit = async (data) => {
        try {
            const formData = new FormData();

            // ✅ Basic Details
            formData.append("id", doctorId); // 🔥 IMPORTANT - Use doctorId from route state
            formData.append("full_name", data?.name || "");
            formData.append("email", data?.email || "");
            formData.append("phone", data?.mobile || "");

            formData.append(
                "date_of_birth",
                data?.dob ? moment(data.dob).format("YYYY-MM-DD") : ""
            );

            formData.append("gender", data?.gender?.value || "");

            // ✅ Department & Specialization
            formData.append("departmentId", data?.test?.value || "");
            formData.append("specializationId", data?.specialization?.value || "");

            // ✅ Extra Fields
            formData.append("address", data?.address || "");
            formData.append("medical_school", data?.medicalSchool || "");
            formData.append("graduation_year", data?.graduationYear || "");
            formData.append("years_of_experience", data?.yearsOfExperience || "");

            // ✅ Profile Image
            if (data?.profile_img instanceof File) {
                formData.append("image", data.profile_img);
            }

            // ✅ PAN Image
            if (data?.pan_img instanceof File) {
                formData.append("pan_image", data.pan_img);
            }

            // ✅ Certificate Image
            if (data?.cert_img instanceof File) {
                formData.append("cert_image", data.cert_img);
            }

            // ✅ Aadhaar Front Image
            if (data?.aadhaar_f_img instanceof File) {
                formData.append("aadhaar_f_image", data.aadhaar_f_img);
            }

            // ✅ Aadhaar Back Image
            if (data?.aadhaar_b_img instanceof File) {
                formData.append("aadhaar_b_image", data.aadhaar_b_img);
            }

            // ✅ DEBUG
            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }

            // ✅ Loading
            setValue("isLoading", true);

            // 🔥 CALL UPDATE API
            const res = await updateHospitalDoctor(formData);

            setValue("isLoading", false);

            if (res?.data?.status === true) {
                toast.success(res.data.message);

                navigate("/doctor-additional-details", {
                    state: {
                        doctorId: doctorId,
                        mode: "Edit"
                    }
                });

            } else if (res?.data?.status === false) {
                toast.error(res.data.message);

            } else if (res?.data?.status === "expired") {
                toast.error(res.data.message);
                logout();
            }

        } catch (error) {
            setValue("isLoading", false);
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    useEffect(() => {
        getDepartments();
    }, []);

    const getDepartments = async () => {
        try {
            const res = await departmentDropDownList({});

            if (res?.data?.status === true) {
                setDepartments(res?.data?.data || []); // ✅ DIRECT USE
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (selectedDepartment?.value) {
            getSpecializations(selectedDepartment.value);
        } else {
            setSpecializationOptions([]);
        }
    }, [selectedDepartment]);
    const getSpecializations = async (departmentId) => {
        try {
            const res = await specializationDropDownList({
                departmentId: departmentId, // ✅ send only value
            });

            if (res?.data?.status === true) {
                setSpecializationOptions(res?.data?.data || []);
            } else {
                setSpecializationOptions([]);
            }
        } catch (err) {
            console.log(err);
            setSpecializationOptions([]);
        }
    };


    return (
        <>
            <Head title={"Doctor Registration | Basic Details"} />
            <Content>
                <BlockHead size={"sm"}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                {"Doctor Registration"}
                            </BlockTitle>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="">
                                <Button
                                    color="primary"
                                    outline
                                    className={`  me-n1`}
                                    onClick={() => {
                                        navigate("/add-hospital-doctor");
                                    }}
                                >
                                    <Icon name={"arrow-left"} />
                                </Button>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <PreviewAltCard>
                        <StepHead current={1} />
                        <Form onSubmit={handleSubmit(mode === "Edit" ? updateDoctorEdit : onFormSubmit)}>
                            <Row className=" ">
                                <div className="d-flex gap-5 py-3 mb-3">
                                    {" "}
                                    <h5>{"Basic Details"}</h5>
                                </div>
                                <Col md="4">
                                    <MySelect
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Department Name"
                                        name="test"
                                        placeholder="Enter Department name"
                                        required
                                        options={departments}
                                    />
                                </Col>
                                <Col md="4">
                                    <MySelect
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Specialization"
                                        name="specialization"
                                        placeholder="Enter specialization"
                                        required
                                        options={specializationOptions}
                                    />
                                </Col>
                                <Col md="4">
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Your Name"
                                        name="name"
                                        placeholder="Enter Your Name"
                                        required
                                        disabled={mode == "Approval"}
                                    />
                                </Col>
                                <Col md="4">
                                    <MyEmail
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Email Address"
                                        name="email"
                                        placeholder="Enter Email Address"
                                        required
                                        disabled={mode == "Approval"}
                                    />
                                </Col>
                                <Col md="4" className={``}>
                                    <MyMobile
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Mobile"}
                                        name={"mobile"}
                                        placeholder={"Enter mobile"}
                                        required
                                        disabled={mode == "Approval"}
                                        readOnly={mode == "Edit"}
                                    />
                                </Col>
                                <Col md="4" className={``}>
                                    <MyDate
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Date of Birth"}
                                        name={"dob"}
                                        placeholder={"Enter date of birth"}
                                        required
                                        max={moment().subtract(20, "years").toDate()}
                                        min={moment().subtract(90, "years").toDate()}
                                        disabled={mode == "Approval"}
                                    />
                                </Col>

                                <Col md={4}>
                                    <MySelect
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title={"Gender"}
                                        name={"gender"}
                                        placeholder={"Select gender"}
                                        required
                                        options={[
                                            { value: "Male", label: "Male" },
                                            { value: "Female", label: "Female" },
                                            { value: "Other", label: "Other" },
                                        ]}
                                        disabled={mode == "Approval"}
                                    />
                                </Col>
                                <Col md="4">
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Full Address"
                                        name="address"
                                        placeholder="Enter full address"
                                        required
                                    />
                                </Col>

                                <Col md="4">
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Medical School"
                                        name="medicalSchool"
                                        placeholder="Enter medical school"
                                        required
                                    />
                                </Col>
                                <Col md="4">
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Graduation Year"
                                        name="graduationYear"
                                        placeholder="Enter graduation year"
                                        required
                                    // disabled={mode == "Approval"}
                                    />
                                </Col>
                                <Col md="4">
                                    <MyInput
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        title="Years of Experience"
                                        name="yearsOfExperience"
                                        placeholder="Enter years of experience"
                                        required
                                    // disabled={mode == "Approval"}
                                    />
                                </Col>
                                <Col md="4">
                                    <ImageUpload
                                        getValues={getValues}
                                        design={4}
                                        id="profile_image"
                                        watch={watch}
                                        trigger={trigger}
                                        setError={setError}
                                        clearErrors={clearErrors}
                                        label={"Profile Image"}
                                        errors={errors}
                                        register={register}
                                        image={"profile_img"}
                                        image_url={"profile_image"}
                                        setValue={setValue}
                                        handleImageOpenPreview={handleImageOpenPreview}
                                        required
                                        approve={mode === "Approval" ? true : false}
                                        size={400}
                                    />
                                </Col>
                            </Row>
                            {(mode == "Add" || mode == "Edit") && (
                                <Row>
                                    <Col md="12" className={``}>
                                        <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                                            <MyButton isLoading={isLoading} mode={mode} />
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Form>
                    </PreviewAltCard>
                </Block>
            </Content>
        </>
    );
};

export default DoctorForm;
